(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAddToCartFeedback() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form') return;

      document.querySelectorAll('product-form form [type="submit"]').forEach(function (button) {
        pulseButton(button);
      });
    });
  }

  function initFlyToCart() {
    var cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;

    document.querySelectorAll('product-form form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var activeImage = document.querySelector('.product__media-item.is-active img')
          || document.querySelector('.product__media-item img');
        if (activeImage) flyImageToCart(activeImage, cartIcon);
      });
    });
  }

  function flyImageToCart(sourceImg, cartIcon) {
    if (prefersReducedMotion || !window.gsap) return;

    var gsap = window.gsap;
    var startRect = sourceImg.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();

    if (!startRect.width || !startRect.height) return;

    var clone = sourceImg.cloneNode(true);
    clone.style.position = 'fixed';
    clone.style.left = startRect.left + 'px';
    clone.style.top = startRect.top + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    clone.style.borderRadius = '0.8rem';
    clone.style.zIndex = '9999';
    clone.style.pointerEvents = 'none';
    clone.style.objectFit = 'cover';
    clone.style.margin = '0';
    document.body.appendChild(clone);

    gsap.to(clone, {
      left: endRect.left + endRect.width / 2 - 12,
      top: endRect.top + endRect.height / 2 - 12,
      width: 24,
      height: 24,
      opacity: 0.5,
      duration: 0.7,
      ease: 'power2.in',
      onComplete: function () {
        clone.remove();
        gsap.fromTo(
          cartIcon,
          { scale: 1 },
          { scale: 1.2, duration: 0.15, yoyo: true, repeat: 1, ease: 'power2.out' }
        );
      },
    });
  }

  function pulseButton(button) {
    var span = button.querySelector('span');
    if (!span || span.dataset.pulsing === 'true') return;

    var originalText = span.textContent;
    span.dataset.pulsing = 'true';

    function restore() {
      span.textContent = originalText;
      delete span.dataset.pulsing;
    }

    if (prefersReducedMotion || !window.gsap) {
      span.textContent = 'Added ✓';
      setTimeout(restore, 1500);
      return;
    }

    var gsap = window.gsap;
    var tl = gsap.timeline({ onComplete: restore });

    tl.to(button, { scale: 0.96, duration: 0.12, ease: 'power2.out' })
      .to(button, { scale: 1.04, duration: 0.22, ease: 'back.out(2.5)' })
      .to(button, { scale: 1, duration: 0.16, ease: 'power2.out' }, '-=0.04')
      .call(
        function () {
          span.textContent = 'Added ✓';
        },
        null,
        0.1
      )
      .to({}, { duration: 1.2 });
  }

  function initGalleryParallax() {
    if (prefersReducedMotion || !window.gsap || !window.ScrollTrigger) return;

    var items = document.querySelectorAll('.product__media-list .product__media-item');
    if (!items.length) return;

    var gsap = window.gsap;

    items.forEach(function (item) {
      var target = item.querySelector('img, video, model-viewer, iframe');
      if (!target) return;

      gsap.fromTo(
        target,
        { yPercent: -4 },
        {
          yPercent: 4,
          ease: 'none',
          scrollTrigger: {
            trigger: item,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        }
      );
    });
  }

  function initProductTabs() {
    document.querySelectorAll('[data-av-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      if (!tabs.length) return;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('aria-controls');
          tabs.forEach(function (item) {
            var selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            var active = panel.id === targetId;
            panel.classList.toggle('is-active', active);
            if (active) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });
        });
      });
    });
  }

  function init() {
    initAddToCartFeedback();
    initGalleryParallax();
    initFlyToCart();
    initProductTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
